<template>
    <div>
    <header>
            <div>
                <h2 class="header_side_eng">{{ recordtoshow.nameeng }}</h2>
                <h2 class="header_side_ch">{{ recordtoshow.namech }}</h2>
            </div>
            <div>
                <span class="header_side_idtag">{{ recordtoshow.recordid }}</span>
            </div>
    </header>
    <section class="mainbody">
        <!-- DATA SECTION: LIST TEXT-->
        <section class="data_module" v-if="recordtoshow.creatoreng || recordtoshow.creatorch">
            <h4 class="data_title"><span class="data_title_ch">創作者</span> <span class="data_title_eng">Creator</span></h4>
            <div class="data_module_list">
                <p class="data_eng"><span class="blackbackground">{{ recordtoshow.creatoreng }}</span></p>
                <p class="data_ch"><span class="blackbackground">{{ recordtoshow.creatorch }}</span></p>
            </div>
        </section>
        <!-- DATA SECTION: LIST TEXT-->
        <section class="data_module" v-if="recordtoshow.foundryeng || recordtoshow.foundrych">
            <h4 class="data_title"><span class="data_title_ch">團體</span> <span class="data_title_eng">Type Foundry</span></h4>
            <div class="data_module_list">
                <p class="data_eng"><span class="blackbackground">{{ recordtoshow.foundryeng }}</span></p>
                <p class="data_ch"><span class="blackbackground">{{ recordtoshow.foundrych }}</span></p>
            </div>
        </section>
        <!-- DATA SECTION: PARAGRAPH -->
        <section class="data_module" v-if="recordtoshow.creationdisplaydate">
            <h4 class="data_title"><span class="data_title_ch">創作日期</span> <span class="data_title_eng">Creation Display Date</span></h4>
            <p class="data_eng">{{ recordtoshow.creationdisplaydate }}</p>
        </section>
        <!-- DATA SECTION: LIST TEXT-->
        <section class="data_module" v-if="recordtoshow.creationbegindate || recordtoshow.creationenddate">
            <h4 class="data_title"><span class="data_title_ch">創作日期</span> <span class="data_title_eng">Creation Date</span></h4>
            <div class="data_module_list">
                <p class="data_eng"><span class="blackbackground">{{ recordtoshow.creationbegindate }}</span></p>
                <p class="data_eng"><span class="blackbackground">{{ recordtoshow.creationenddate }}</span></p>
            </div>
        </section>
        <!-- DATA SECTION: LIST TEXT-->
        <section class="data_module" v-if="recordtoshow.placeeng || recordtoshow.placech">
            <h4 class="data_title"><span class="data_title_ch">創作位置</span> <span class="data_title_eng">Place</span></h4>
            <div class="data_module_list">
                <p class="data_eng"><span class="blackbackground"><a :href="recordtoshow.placeurl" target="_blank">{{ recordtoshow.placeeng }}</a></span></p>
                <p class="data_ch"><span class="blackbackground"><a :href="recordtoshow.placeurl" target="_blank">{{ recordtoshow.placech }}</a></span></p>
            </div>
        </section>
        <!-- DATA SECTION: PARAGRAPH -->
        <section class="data_module" v-if="recordtoshow.material">
            <h4 class="data_title"><span class="data_title_ch">載體材料 </span> <span class="data_title_eng">Materials</span></h4>
            <p class="data_eng">{{ recordtoshow.material }}</p>
        </section>
        <!-- DATA SECTION: PARAGRAPH -->
        <section class="data_module" v-if="recordtoshow.technique">
            <h4 class="data_title"><span class="data_title_ch">技術 </span> <span class="data_title_eng">Technique</span></h4>
            <p class="data_eng">{{ recordtoshow.technique }}</p>
        </section>
        <!-- DATA SECTION: LIST TEXT-->
        <section class="data_module" v-if="recordtoshow.genreeng || recordtoshow.genrech">
            <h4 class="data_title"><span class="data_title_ch">風格</span> <span class="data_title_eng">Genre</span></h4>
            <div class="data_module_list">
                <p class="data_eng"><span class="blackbackground">{{ recordtoshow.genreeng }}</span></p>
                <p class="data_ch"><span class="blackbackground">{{ recordtoshow.genrech }}</span></p>
            </div>
        </section>
        <!-- DATA SECTION: LIST TEXT-->
        <section class="data_module" v-if="recordtoshow.subgenreeng || recordtoshow.subgenrech">
            <h4 class="data_title"><span class="data_title_ch">風格</span> <span class="data_title_eng">Subgenre</span></h4>
            <div class="data_module_list">
                <p class="data_eng"><span class="blackbackground">{{ recordtoshow.subgenreeng }}</span></p>
                <p class="data_ch"><span class="blackbackground">{{ recordtoshow.subgenrech }}</span></p>
            </div>
        </section>
        <!-- DATA SECTION: PARAGRAPH -->
        <section class="data_module" v-if="recordtoshow.style">
            <h4 class="data_title"><span class="data_title_ch">系列 </span> <span class="data_title_eng">Styles</span></h4>
            <p class="data_eng">{{ recordtoshow.style }}</p>
        </section>
        <!-- DATA SECTION: PARAGRAPH -->
        <section class="data_module" v-if="recordtoshow.size">
            <h4 class="data_title"><span class="data_title_ch">字號 </span> <span class="data_title_eng">Sizes</span></h4>
            <p class="data_eng">{{ recordtoshow.size }}</p>
        </section>
        <!-- DATA SECTION: PARAGRAPH -->
        <section class="data_module" v-if="recordtoshow.note">
            <h4 class="data_title"><span class="data_title_ch">註解 </span> <span class="data_title_eng">Notes</span></h4>
            <p class="data_eng" v-html="recordtoshow.note"></p>
        </section>
        <!-- DATA SECTION: PARAGRAPH -->
        <section class="data_module" v-if="recordtoshow.publication">
            <h4 class="data_title"><span class="data_title_ch">文獻 </span> <span class="data_title_eng">Publications</span></h4>
            <p class="data_eng" v-html="recordtoshow.publication"></p>
        </section>
        <!-- DATA SECTION: PARAGRAPH -->
        <section class="data_module" v-if="recordtoshow.footnote">
            <h4 class="data_title"><span class="data_title_ch">註腳 </span> <span class="data_title_eng">Footnotes</span></h4>
            <p class="data_eng" v-html="recordtoshow.footnote"></p>
        </section>
    </section>
    </div>
</template>

<script>
export default {
    name: 'RecordTypeface',
    props:{
        //This is an array containing all the info for 1 record
        recordtoshow: Object
    }
}
</script>